import React, { useEffect, useState } from "react";

import SmartRtpEditFormLoader from "./components/SmartRtpEditFormLoader";
import {
  getBuyerRewardRuleById,
  getBuyerRewardRules,
  getGamesList,
  saveBuyerRewardRule,
} from "../../../controllers/V1/smartRtp/smartRtpController";

export default function SmartRtpBuyerRewardFormPage() {
  const [gameOptions, setGameOptions] = useState([{ label: "Global", value: null }]);

  useEffect(() => {
    const loadGames = async () => {
      const res = await getGamesList({ type: "", condition: {}, limit: 0, skip: 0, sort: { title: 1 } });
      if (res.status === true) {
        setGameOptions([
          { label: "Global", value: null },
          ...(res.result || []).map((item) => ({ label: item.title, value: item._id })),
        ]);
      }
    };
    loadGames();
  }, []);

  const resolveByGameId = async (gameId) => {
    const res = await getBuyerRewardRules({
      type: "",
      condition: { game_id: gameId },
      limit: 1,
      skip: 0,
      sort: { createdAt: -1 },
    });
    if (res?.status === true && Array.isArray(res.result) && res.result.length > 0) {
      return res.result[0];
    }
    return null;
  };

  const fields = [
    { name: "rule_code", label: "Rule Code", rules: [{ required: true, message: "Rule code is required." }] },
    { name: "title", label: "Title" },
    {
      name: "game_id",
      label: "Game Scope",
      type: "select",
      options: gameOptions,
    },
    { name: "loss_streak_threshold", label: "Loss Streak Threshold", type: "number", rules: [{ required: true, message: "Threshold is required." }] },
    {
      name: "compassion_window_orders",
      label: "Random Win Window (orders after losses)",
      type: "number",
      props: { min: 1, max: 20 },
    },
    {
      name: "boost_type",
      label: "Boost Type",
      type: "select",
      options: [
        { label: "Pool Boost", value: "PoolBoost" },
        { label: "Slab Upgrade", value: "SlabUpgrade" },
        { label: "Guaranteed Minimum", value: "GuaranteedMin" },
        { label: "Probability Boost", value: "ProbabilityBoost" },
      ],
      rules: [{ required: true, message: "Boost type is required." }],
    },
    { name: "boost_value", label: "Boost Value", type: "number", rules: [{ required: true, message: "Boost value is required." }] },
    { name: "max_boosts_per_buyer_per_day", label: "Daily Boost Limit", type: "number" },
    { name: "cooldown_orders", label: "Cooldown Orders", type: "number" },
    {
      name: "restrict_to_consolation_slabs",
      label: "Restrict To Consolation",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { label: "Active", value: "A" },
        { label: "Inactive", value: "I" },
        { label: "Deleted", value: "D" },
      ],
    },
  ];

  return (
    <SmartRtpEditFormLoader
      titlePrefix="Smart RTP Buyer Reward Rule"
      backTo="/smart-rtp/games"
      fields={fields}
      fetchById={getBuyerRewardRuleById}
      resolveByGameId={resolveByGameId}
      defaultsForGameId={(gameId) => ({ game_id: gameId })}
      onSave={(values, editId) =>
        saveBuyerRewardRule({ ...values, ...(editId ? { editId } : {}) })
      }
      defaultValues={{
        loss_streak_threshold: 3,
        compassion_window_orders: 3,
        boost_type: "GuaranteedMin",
        boost_value: 1,
        max_boosts_per_buyer_per_day: 50,
        cooldown_orders: 0,
        restrict_to_consolation_slabs: true,
        status: "A",
      }}
    />
  );
}
